
import { FetchParams, ResultData, SortDirection } from "@nt-portal/common-sdk";
import { LazyOptions } from "../../types";


/**
 * Creates an empty ResultData instance with default pagination settings.
 * @returns Result container with zeroed paging metadata and an empty data array.
 */
export const initResultData = <T>(): ResultData<T> => {
    return {
        data: new Array<T>(),
        limit: 10,
        skip: 0,
        total: 0
    }
  }
  
  /**
   * Provides default lazy loading options for PrimeReact data components.
   * @returns LazyOptions pre-populated with standard paging and sorting values.
   */
  export const initLazyOptions = () => {
    let item: LazyOptions = {
        first: 0,
        rows: 50,
        page: 0,
        sortField: 'startTime',
        sortOrder: -1
    }
    return item;
  }
  
  /**
   * Translates lazy loading options into backend fetch parameters.
   * @param params Table lazy options containing pagination and sorting state.
   * @returns FetchParams configured for use with the common SDK.
   */
  export const buildFetchParams = (params: LazyOptions) => {
    let fetchParams = new FetchParams();
    fetchParams.limit = params.rows;
    fetchParams.skip = params.page && params.rows ? params.page * params.rows : 0;
    fetchParams.orderBy = params.sortField;
    fetchParams.orderDir = params.sortOrder === 1 ? SortDirection.ASC : SortDirection.DESC;
    return fetchParams;
  }